import * as form from '../form';

export const substanceDrugPurchase = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        DrugType: form.radio(xitem.DrugType),
        DrugTypeOther: form.textarea(xitem.DrugTypeOther),
        FirstInvolvement: form.datecontrol(xitem.FirstInvolvement),
        RecentInvolvement: form.datecontrol(xitem.RecentInvolvement),
        HowManyTimes: form.text(xitem.HowManyTimes),
        NatureOfInvolvement: form.textarea(xitem.NatureOfInvolvement),
        InvolvementWhileEmployed: form.branch(xitem.InvolvementWhileEmployed),
        InvolvementWhileEmployedPosition: form.text(xitem.InvolvementWhileEmployedPosition),
        InvolvementWhileEmployedExplanation: form.textarea(xitem.InvolvementWhileEmployedExplanation),
        InvolvementWithClearance: form.branch(xitem.InvolvementWithClearance),
        InvolvementWithClearanceExplanation: form.textarea(xitem.InvolvementWithClearanceExplanation),
        InvolvementInFuture: form.branch(xitem.InvolvementInFuture),
        Reasons: form.textarea(xitem.Reasons),
        Explanation: form.textarea(xitem.Explanation),
        Comments: form.textarea(xitem.Comments),
        InvolvementInFutureComments: form.textarea(xitem.InvolvementInFutureComments),
      },
    };
  });
  return {
    Involved: form.branch(data.Involved),
    List: form.collection(items, (data.List || {}).branch),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
  };
};
